import { AuthGuard } from '@/features/auth/components/AuthGuard';

export function AppLayout() {
  return <AuthGuard />;
}
